export const getTagColor = (val) => {
  if (['gold'].includes(val)) {
    return val;
  }

  return 'default';
};
